module.exports = __webpack_public_path__ + "img/hbo.cee1609b.png";